import { render, staticRenderFns } from "./DashBoardInner.vue?vue&type=template&id=55147d84"
import script from "./DashBoardInner.vue?vue&type=script&lang=js"
export * from "./DashBoardInner.vue?vue&type=script&lang=js"
import style0 from "./DashBoardInner.vue?vue&type=style&index=0&id=55147d84&prod&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports